/* eslint-disable react/prop-types */
import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import HotelIcon from '@mui/icons-material/Hotel';
import BedIcon from '@mui/icons-material/Bed';
import ScheduleIcon from '@mui/icons-material/Schedule';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SmartToyIcon from '@mui/icons-material/SmartToy';

const Item = ({ icon, text }) => (
  <Stack direction="row" spacing={1.5} alignItems="center">
    {icon}
    <Typography variant="body1">{text}</Typography>
  </Stack>
);

export default function StepWelcome({ hotel, onNext }) {
  const theme = useTheme();

  return (
    <Stack spacing={3} alignItems="center" sx={{ textAlign: 'center', py: 2 }}>
      <Box
        sx={{
          width: 88,
          height: 88,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: alpha(theme.palette.primary.main, 0.1)
        }}
      >
        <HotelIcon sx={{ fontSize: 44, color: theme.palette.primary.main }} />
      </Box>

      <Typography variant="h3">¡Bienvenido, {hotel?.name || 'Hotel'}!</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 460 }}>
        Vamos a dejar tu hotel listo para recibir reservas. Son 5 pasos y te tomará menos de 10 minutos. Tu avance se guarda
        automáticamente: puedes salir y continuar después donde quedaste.
      </Typography>

      <Stack spacing={1.5} alignItems="flex-start" sx={{ py: 1 }}>
        <Item icon={<BedIcon color="primary" />} text="Tus tipos de habitación y cuántas tienes de cada una" />
        <Item icon={<ScheduleIcon color="primary" />} text="Tipos de estancia (por noche y, si ofreces, por horas)" />
        <Item icon={<AttachMoneyIcon color="primary" />} text="Precios por tipo de habitación y estancia" />
        <Item icon={<HotelIcon color="primary" />} text="Datos de tu hotel: horarios, impuestos y contacto" />
        <Item icon={<SmartToyIcon color="primary" />} text="Asistente Sego IA por WhatsApp (opcional)" />
      </Stack>

      <Button variant="contained" size="large" onClick={onNext} sx={{ px: 6, py: 1.5, borderRadius: 2, fontWeight: 600 }}>
        Comenzar
      </Button>
    </Stack>
  );
}
